import version from './version'
import geoLocation from './global-api/geo-location'
import getCode from './global-api/get-code'
import getOpenIdRedirect from './global-api/get-openid-redirect'
import setShare from './global-api/set-share'
import setPageTitle from './global-api/set-page-title'
import pay from './global-api/pay'
import isLogin from './global-api/is-login'
import forceLogin from './global-api/force-login'
import onWeChatReady from './hook/hook'
import { assert } from './util/tool'

assert(typeof Promise !== 'undefined', 'requires a Promise polyfill in this browser.')

export default {
  geoLocation,
  getCode,
  getOpenIdRedirect,
  setShare,
  setPageTitle,
  pay,
  isLogin,
  forceLogin,
  onWeChatReady,
  version
}
